import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, CircularProgress, Alert, Box, useMediaQuery, useTheme, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  showReason?: boolean;
  reasonLabel?: string;
  reasonPlaceholder?: string;
  maxReasonLength?: number;
  onConfirm: (reason?: string) => Promise<void>;
  onCancel: () => void;
  isLoading?: boolean;
  error?: string;
}
const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  showReason = false,
  reasonLabel = 'Reason (optional)',
  reasonPlaceholder = 'Enter reason...',
  maxReasonLength = 200,
  onConfirm,
  onCancel,
  isLoading = false,
  error
}) => {
  const [reason, setReason] = useState('');
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const handleConfirm = () => {
    onConfirm(showReason ? reason : undefined);
  };
  return <Dialog open={open} onClose={isLoading ? undefined : onCancel} maxWidth="sm" fullWidth fullScreen={fullScreen} PaperProps={{
    sx: {
      borderRadius: fullScreen ? 0 : 3,
      overflow: 'hidden'
    }
  }} aria-labelledby="confirm-dialog-title" aria-describedby="confirm-dialog-description" data-id="element-2471">
      {fullScreen && <Box sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      p: 1,
      borderBottom: '1px solid',
      borderColor: 'divider'
    }} data-id="element-2472">
          <IconButton edge="end" color="inherit" onClick={onCancel} aria-label="close" disabled={isLoading} data-id="element-2473">
            <Icon icon="lucide:x" width={24} height={24} data-id="element-2474" />
          </IconButton>
        </Box>}
      <DialogTitle id="confirm-dialog-title" data-id="element-2475">{title}</DialogTitle>
      <DialogContent data-id="element-2476">
        <DialogContentText id="confirm-dialog-description" sx={{
        mb: 2
      }} data-id="element-2477">
          {message}
        </DialogContentText>
        {error && <Alert severity="error" sx={{
        mb: 2,
        borderRadius: 2
      }} variant="outlined" data-id="element-2478">
            {error}
          </Alert>}
        {showReason && <TextField autoFocus label={reasonLabel} placeholder={reasonPlaceholder} fullWidth multiline rows={3} value={reason} onChange={e => setReason(e.target.value)} inputProps={{
        maxLength: maxReasonLength
      }} helperText={`${reason.length}/${maxReasonLength}`} disabled={isLoading} sx={{
        mt: 2
      }} data-id="element-2479" />}
      </DialogContent>
      <DialogActions sx={{
      p: 2,
      justifyContent: 'flex-end',
      gap: 1,
      borderTop: '1px solid',
      borderColor: 'divider'
    }} data-id="element-2480">
        <Button onClick={onCancel} color="inherit" variant="outlined" disabled={isLoading} data-id="element-2481">
          {cancelLabel}
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" disabled={isLoading} startIcon={isLoading ? <CircularProgress size={20} color="inherit" data-id="element-2483" /> : null} data-id="element-2482">
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>;
};
export default ConfirmDialog;